import React, { useState, useEffect } from "react";
import { ISelectedRange } from "../../../../components/subtitles/SubtitlesTypes";
import { ISubtitles } from "../../../../types/videoResponse";
import "./SubtitlesWidgetSaving.css";

interface ISubtitlesWidgetSavingProps {
    subtitles: ISubtitles, 
    selections: Array<ISelectedRange>, 
    save: ()=>Promise<any>
}

export const SubtitlesWidgetSaving = ({subtitles, selections, save}: ISubtitlesWidgetSavingProps) => {
    const [savedSubtitles, setSavedSubtitles] = useState<ISubtitles>();
    const [savedSelections, setSavedSelections] = useState<Array<ISelectedRange>>();
    const [status, setStatus] = useState('init');
    const autosave = true;//false;
    useEffect(()=>{
        if (!savedSelections && !savedSubtitles){
            console.log('init selections');
            if (subtitles.selections){
                console.log('restore saved selections');
                setSavedSelections(subtitles.selections);
            } else {
                setSavedSelections(selections);
            }
            setSavedSubtitles(subtitles);
            setStatus('saved');
            return;
        }
        if (savedSubtitles==subtitles && (savedSelections==selections || subtitles.selections == selections)){
            setStatus('saved');
        } else {
            setStatus('write');
        }
        if (!autosave){
            return;
        }
        const tid = setTimeout(()=>{
            if (savedSubtitles!=subtitles){
                console.log('saving subtitles');
                setStatus('upload');
                save().then(()=>{
                    setStatus('saved');
                    setSavedSubtitles(subtitles);
                })    
            }
            if (savedSelections!=selections){
                console.log('saving selections');
                setStatus('upload');
                setSavedSelections(selections);
                save().then(()=>{
                    setStatus('saved');
                    setSavedSelections(selections);
                })   
            }
        }, 10000);
        return ()=>{
            clearTimeout(tid);
        }
    }, [subtitles, selections]);
    return <div className={`subtitlesWidgetSaving`}>
        <div className={`button subtitlesWidgetSaving_save`} onClick={()=>{
            if (status != 'write'){
                return;
            }
            setStatus('upload');
            save().then(()=>{
                setStatus('saved');
            })
        }}>
            save
        </div>
        <div className={`subtitlesWidgetSaving_progress`}>
            {status}
        </div>
    </div>
}
